import { Controller } from "@hotwired/stimulus";

export default class TurnstileController extends Controller {
  static targets = ["container", "submit"];
  static values = { siteKey: String };

  async connect() {
    if ("undefined" === typeof window.turnstile) {
      await new Promise(function (resolve) {
        const script = document.createElement("script");
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.defer = true;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }

    this.widgetId = window.turnstile.render(this.containerTarget, {
      sitekey: this.siteKeyValue,
      callback: () => this.submitTargets.forEach((submit) => submit.removeAttribute("disabled")),
      "error-callback": () => this.submitTargets.forEach((submit) => submit.setAttribute("disabled", true)),
      "expired-callback": () => this.submitTargets.forEach((submit) => submit.setAttribute("disabled", true)),
    });
  }

  disconnect() {
    window.turnstile.remove(this.widgetId);
  }
}
